module.exports = __webpack_public_path__ + "static/media/lukas.3c26b577.jpg";